/* eslint-disable no-console */

import { register as registerSW } from 'register-service-worker';

export function register() {
  if (process.env.NODE_ENV === 'production') {
    registerSW(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        );
      },
      registered() {
        console.log('Service worker has been registered.');
      },
      cached() {
        console.log('Content has been cached for offline use.');
      },
      updatefound() {
        console.log('New content is downloading.');
      },
      updated(registration) {
        console.log('New content is available; please refresh.');
        // You can add a UI element here to prompt the user to refresh.
        // For example, by dispatching a custom event:
        document.dispatchEvent(
          new CustomEvent('swUpdated', { detail: registration })
        );
      },
      offline() {
        console.log('No internet connection found. App is running in offline mode.');
      },
      error(error) {
        console.error('Error during service worker registration:', error);
      },
    });
  }
}